// extracted by mini-css-extract-plugin
export default {"labelField":"LabelField_labelField__v++Wu"};